var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('ModalPDPA',{ref:"ModalPDPA"}),_c('keep-alive',{attrs:{"max":10}},[_c('router-view')],1),_c('Loader'),_c('LoaderSaleMan')],1)}
var staticRenderFns = []

export { render, staticRenderFns }